import Row from '~/grid/Row';
import Col from '~/grid/Col';
import { Content, Description } from './Tabs.styles';

/**
 * @param {TabsProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Tabs = ({ items, activeItems, onChange }) => {
  return (
    <Row>
      <Col colAmount={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }}>
        {items.map((item, idx) => (
          <Description
            key={idx}
            role="button"
            onClick={() => onChange(idx)}
            active={activeItems.includes(idx)}
          >
            {item.description}
          </Description>
        ))}
      </Col>
      <Col colAmount={{ xl: 8, lg: 8, md: 8, sm: 12, xs: 12 }}>
        {items.map((item, idx) => (
          <Content key={idx} active={activeItems.includes(idx)}>
            {item.column}
          </Content>
        ))}
      </Col>
    </Row>
  );
};

export default Tabs;
